import * as React from "react";
import './floortoolbar.css';
import { useState } from "react";
import { AiOutlineCheck } from "react-icons/ai";
import { RxCross1 } from "react-icons/rx";
import { tactile } from "../_shared/feedback";

function ToolSwitch(props) {
    const [isEnabled, setIsEnabled] = useState(props.enabled);

    const handleClick = (e) => {
        // a crisp industrial switch THROW — haptic buzz + click, gated by the
        // global mute (haptic still fires when muted).
        tactile({ kind: "switch", sound: props.sound !== false });
        props.toggle(!isEnabled);
        setIsEnabled(!isEnabled);
    }

    return (
        <div className="toolswitch-wrapper">
            <div className="toolswitch">
                <h1 className="switch-title">{props.switchname}</h1>
                <button className="switch-btn" onClick={handleClick} style={isEnabled ? enabledStyles : disabledStyles}>
                    {
                        isEnabled ?
                            <AiOutlineCheck />
                            :
                            <RxCross1 />
                    }
                </button>
            </div>
        </div>
    );
}

const enabledStyles = {
    background: "#59C9A5",
}

const disabledStyles = {
    background: "#D81E5B",
}

// A faintly random screw/bolt tilt, the way the old floor tray did it — keeps the
// hand-assembled look now that the panel stands vertical.
const rot = () => ({ transform: "rotateZ(" + (Math.random() * 25) + "deg)" });

// The floor "Settings" tray, refactored from a bottom bar into a TOGGLEABLE LEFT
// SIDEBAR with a hamburger. It used to sit across the bottom of the screen and
// collided with the music dock / mini player pinned lower-right; standing it up
// on the left clears that corner entirely. Same brushed-metal / bolt / dashed /
// toggle styling — just reorganised.
function FloorToolbar(props) {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = (e) => {
        // On touch, preventDefault on touchEnd stops the browser from also firing
        // a synthesized click that would immediately toggle back.
        if (e && e.type === "touchend" && e.preventDefault) {
            e.preventDefault();
        }
        // a heavy mechanical latch CHUNK as the worn panel slides open / shut.
        tactile({ kind: "load", sound: props.sound !== false });
        setIsOpen((o) => !o);
    }

    return (
        <React.Fragment>
            {/* Hamburger toggle — a riveted metal pad pinned lower-left (clear of
                the dock / mini player on the right). Morphs to an X while open. */}
            <button
                type="button"
                className={"toolbar-fab" + (isOpen ? " is-open" : "")}
                onClick={toggle}
                onTouchEnd={toggle}
                aria-label={isOpen ? "Close settings" : "Open settings"}
                aria-expanded={isOpen}
                title="Settings"
            >
                <span className="toolbar-fab-lines" aria-hidden="true">
                    <span /><span /><span />
                </span>
            </button>

            {/* Scrim (mobile) — tap outside the panel to close. */}
            <div
                className={"toolbar-scrim" + (isOpen ? " is-open" : "")}
                onClick={toggle}
                onTouchEnd={toggle}
                aria-hidden="true"
            />

            {/* The settings SIDEBAR — slides in from the left. */}
            <aside
                className={"toolbar-side" + (isOpen ? " is-open" : "")}
                role="region"
                aria-label="Settings"
                aria-hidden={!isOpen}
            >
                <div className="toolbar side-rail">
                    <div className="bolt-wrapper">
                        <div className="bolt" style={rot()} />
                        <div className="screw" style={rot()} />
                    </div>

                    <div className="settings-wrapper">
                        <div className="title-wrapper-toolbar">
                            <hr className="dashed"></hr>

                            <h1 className="title-text-toolbar">
                                {"> Settings <"}
                            </h1>

                            <hr className="dashed"></hr>
                        </div>

                        <div className="switches-wrapper">
                            <ToolSwitch sound={props.sound} switchname='-Filter-' enabled={true} toggle={props.tFilter} />
                            <ToolSwitch sound={props.sound} switchname='*Grid*' enabled={true} toggle={props.tGrid} />
                            <ToolSwitch sound={props.sound} switchname='^Invert^' enabled={false} toggle={props.tInversion} />
                            <ToolSwitch sound={props.sound} switchname='~Music~' enabled={true} toggle={props.tSounds} />
                            <ToolSwitch sound={props.sound} switchname='~Annex~' enabled={false} toggle={props.tAnnex} />
                            <ToolSwitch sound={props.sound} switchname='+VHS+' enabled={true} toggle={props.tVhs} />
                            <ToolSwitch sound={props.sound} switchname='*X-RAY*' enabled={false} toggle={props.tXray} />
                        </div>

                        <hr className="dashed"></hr>

                        <button
                            type="button"
                            className="side-close"
                            onClick={toggle}
                            onTouchEnd={toggle}
                        >
                            <RxCross1 /> CLOSE
                        </button>
                    </div>

                    <div className="bolt-wrapper">
                        <div className="screw" style={rot()} />
                        <div className="bolt" style={rot()} />
                    </div>
                </div>
            </aside>
        </React.Fragment >
    );
}

export default FloorToolbar;
